export function hide(Player) {
  Player.player.el().style.display = 'none';
}

export function show(Player) {
  Player.player.el().style.display = '';
}
